import { render, staticRenderFns } from "./deleteApprovalDialog.vue?vue&type=template&id=2c514837&scoped=true"
import script from "./deleteApprovalDialog.vue?vue&type=script&lang=js"
export * from "./deleteApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteApprovalDialog.vue?vue&type=style&index=0&id=2c514837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c514837",
  null
  
)

export default component.exports